export const contentCardsContainerStyles = {
  '& > div:not(:last-child)': {
    marginRight: ['0px', '0px', '24px'],
    marginBottom: ['15px', '15px', '0px'],
  },
  display: 'flex',
  flexDirection: ['column', 'column', 'row'],
  alignItems: 'center',
}
